package com.crowpay.utils

import com.crowpay.views.theming.AppColors
import com.crowpay.views.theming.ColorSet
import com.crowpay.views.theming.DismissibleBannerHandler
import com.crowpay.views.theming.NotificationBarSemantic
import com.crowpay.views.theming.body
import com.crowpay.views.theming.dismissibleBanner
import com.lightningkite.kiteui.reactive.ReactiveContext
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.reactive.reactive
import com.lightningkite.kiteui.reactive.shared
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.onlyWhen
import com.lightningkite.kiteui.views.dynamicTheme
import com.lightningkite.kiteui.views.forEachUpdating

data class Banner(
    val name: String,
    val color: ColorSet,
    val message: ReactiveContext.() -> String
) {
    companion object {
        fun info(name: String, message: ReactiveContext.() -> String) = Banner(name, AppColors.blue, message)
        fun warn(name: String, message: ReactiveContext.() -> String) = Banner(name, AppColors.yellow, message)
        fun danger(name: String, message: ReactiveContext.() -> String) = Banner(name, AppColors.red, message)
    }

    class Builder {
        val banners = ArrayList<Banner>()

        fun info(name: String, message: ReactiveContext.() -> String) { banners.add(Banner.info(name, message)) }
        fun warn(name: String, message: ReactiveContext.() -> String) { banners.add(Banner.warn(name, message)) }
        fun danger(name: String, message: ReactiveContext.() -> String) { banners.add(Banner.danger(name, message)) }

        fun info(name: String, message: String) = info(name) { message }
        fun warn(name: String, message: String) = warn(name) { message }
        fun danger(name: String, message: String) = danger(name) { message }

        fun info(message: String) = info(message, message)
        fun warn(message: String) = warn(message, message)
        fun danger(message: String) = danger(message, message)
    }
}

fun banners(setup: Banner.Builder.() -> Unit) = Banner.Builder().apply(setup).banners.toList()

fun ViewWriter.renderBanners(banners: Readable<List<Banner>>, hideWhenEmpty: Boolean = true): ViewModifiable {
    if (hideWhenEmpty) onlyWhen { banners().isNotEmpty() }
    return col {
        forEachUpdating(banners, placeholdersWhileLoading = 1) { banner ->
            val handler = shared { DismissibleBannerHandler(banner().name) }
            dismissibleBanner(handler) {
                body {
                    dynamicTheme { NotificationBarSemantic(banner().color) }
                    reactive {
                        setBasicHtmlContent(banner().message())
                    }
                }
            }
        }
    }
}